import Component from '../../lib/component'

export default class FormConditionalElementComponent extends Component {
    static selector () {
        return '[data-form-conditional-element]'
    }

    constructor (opts) {
        super(opts)

        if (!this.el || !this.props.formConditionalElement)
            return

        this.config = this.parseConfig()

        this.render()
        this.listen()
    }

    listen () {
        if (!this.getDependentEls())
            return

        this.getDependentEls()
            .forEach(el => el.addEventListener('change',
                this.render.bind(this)))
    }

    getDependentEls () {
        return this.config.selector
            ? Array.from(document.querySelectorAll(this.config.selector))
            : null
    }

    getWrapperEl () {
        let wrapper = null
        let el = this.el.parentElement

        while (!el.tagName.match(/form/i) && el !== document.body) {
            if (!el.classList.contains('form-conditional-element-wrapper')) {
                el = el.parentElement
                continue
            }

            wrapper = el
            break
        }

        return wrapper
    }

    parseConfig () {
        let data = {}

        try {
            data = JSON.parse(this.props.formConditionalElement
                || '{}')
        }
        catch (e) {
            console.warn(e)
        }

        return data
    }

    render (e) {
        const config = this.config
        const wrapperEl = this.getWrapperEl()

        const dependentEls = this.getDependentEls()
        const dependentEl = dependentEls.length > 1
            ? dependentEls
                .filter(el => (el.value || el.getAttribute('value'))
                    === config.value)[0]
            : dependentEls[0]

        const isEnable = dependentEl
            && !dependentEl.disabled
            && ((dependentEl.value === config.value
                    && (!dependentEl.type.match(/(radio|checkbox)/)
                        || dependentEl.checked))
                || (typeof config.value === 'boolean'
                    && dependentEl.value)
                || ('checked' in config
                    && dependentEl.checked
                        === config.checked)
                || (config.regExp
                    && typeof config.value === 'string'
                    && dependentEl.value.match(
                        new RegExp(config.value,
                            config.regExpFlags || ''))))

        if ((isEnable && this.el.disabled)
                || (!isEnable && !this.el.disabled)) {
            this.el.disabled = !this.el.disabled

            if (!this.el.disabled
                    && this.props.formConditionalElementAutofocus === 'true')
                this.el.focus()
        }

        const wrapperHiddenClassname
            = 'display-none'

        if (this.props.formConditionalElementHide !== 'false'
                && ((isEnable
                        && wrapperEl
                        && wrapperEl.classList
                            .contains(wrapperHiddenClassname))
                    || (!isEnable
                        && wrapperEl
                        && !wrapperEl.classList
                            .contains(wrapperHiddenClassname))))
            wrapperEl.classList.toggle(wrapperHiddenClassname)

        let evt

        try {
            evt = new window.Event('change', { view: window, bubbles: true })
        }
        catch (e) {
            evt = document.createEvent('Event')
            evt.initEvent('change', true, true)
        }

        this.el.dispatchEvent(evt)
    }
}
